import Vue from "vue";
import Router from "vue-router";
import Register from "../pages/Register";
import ResetPassword from "../pages/ResetPassword";
import ResentVerifyEmail from "../pages/ResendVerify";
import ForgetPassword from "../pages/ForgetPasswordEmail";
import VerifyEmail from "../pages/VerifyEmail";
import EmailUpdated from "../pages/EmailUpdated";
import InvalidCode from "../pages/InvalidCode";
import InternalErrorPage from "../pages/InternalError";
import PasswordExpired from "../pages/PasswordExpired";
import UpdatePassword from "../pages/UpdatePassword";
import UpdateProfile from "../pages/UpdateProfile";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: { name: "Register" },
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
    },
    {
      path: "/reset",
      name: "ResetPassword",
      component: ResetPassword,
    },
    {
      path: "/welcome",
      name: "VerifyEmail",
      component: VerifyEmail,
    },
    {
      path: "/updated",
      name: "EmailUpdated",
      component: EmailUpdated,
    },
    {
      path: "/ResendVerify",
      name: "ResendVerify",
      component: ResentVerifyEmail,
    },
    {
      path: "/ForgetPassword",
      name: "ForgetPassword",
      component: ForgetPassword,
    },
    {
      path: "/invalid",
      name: "InvalidCode",
      component: InvalidCode,
    },
    {
      path: "/oops/:code",
      name: "internalServerError",
      component: InternalErrorPage,
    },
    {
      path: "/PasswordExpired",
      name: "PasswordExpired",
      component: PasswordExpired,
    },
    {
      path: "/UpdatePassword",
      name: "UpdatePassword",
      component: UpdatePassword,
    },
    {
      path: "/UpdateProfile",
      name: "UpdateProfile",
      component: UpdateProfile,
    },
  ],
});
